var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.93 512c0 20.77 7.56 37.93 24 54.18l445.45 438c12.89 13.1 28.89 19.87 47.12 19.87 37.79 0 67.57-30.25 67.57-68.18 0-19.41-7.56-36.12-20.89-49.66L380.41 511.55l402.77-394.16a68.91 68.91 0 0020.89-49.21C804.07 30.25 774.29 0 736.5 0c-18.67 0-34.23 6.32-47.12 19.41L243.93 457.82c-16.44 16.25-24 32.96-24 54.18z"
  })));
}
export default SvgBack;